import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const paymentMethodService = { getAll, get, create, update, remove }

const API_URL = API.BASE_URL + '/v1'

/**
 * @param {object} params `include_inactive` for the settings screen; the
 *   picker leaves it off and gets only the methods a customer can use today.
 */
export function getAll(params = {}) {
  return apiHelper(API_URL).get('/payment-methods', { params })
}
export function get(uuid) {
  return apiHelper(API_URL).get(`/payment-methods/${uuid}`)
}
export function create(data) {
  return apiHelper(API_URL).post('/payment-methods', data)
}
export function update(uuid, data) {
  return apiHelper(API_URL).put(`/payment-methods/${uuid}`, data)
}
export function remove(uuid) {
  return apiHelper(API_URL).delete(`/payment-methods/${uuid}`)
}
